import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ITokenResponse } from 'app/core/authentication/models/token-response';
import { UrlService } from 'app/core/http/url.service';

@Injectable({
  providedIn: 'root'
})
export class SessionRefreshApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public refreshToken(): Observable<ITokenResponse> {
    return this.httpClient.post<ITokenResponse>(
      this.urlService.buildServerApiUrl('Auth', 'RefreshToken'),
      null);
  }
}
